<template>
    <a-row>
        <!-- 议题列表 -->
        <a-card :bordered="false" class="list" ref="card">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" ref="forum-search-form">
                    <a-row :gutter="16">
                        <a-col :md="8" :sm="24">
                            <a-form-item :label="language['ispforum.keyword']">
                                <a-input v-model="queryParams.keyword"
                                    :max-length="100"
                                    :placeholder="language['ispforum.search.placeholder']"
                                    @change="handleSearchChange"
                                    @pressEnter="handleSearch" />
                            </a-form-item>
                        </a-col> 
                        <a-col :md="8" :sm="24" v-if="type === 'tags'">
                            <a-form-item :label="language['ispforum.tags']">
                                <a-select v-model="searchTag"
                                    :default-value="0"
                                    @change="handleTagChange">
                                    <a-select-option :value="0">{{ language['ispforum.all'] }}</a-select-option>
                                    <a-select-option v-for="tag in tagsInfo" :key="tag.id" :value="tag.id">{{ tag.title }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-tooltip :title="language['ispforum.search']" placement="top">
                                    <a-button type="primary" @click="handleSearch" icon="search" style="margin-right: 16px"></a-button>
                                </a-tooltip>
                                <a-tooltip :title="language['ispforum.post.issue']" placement="top">
                                    <a-button type="primary" icon="plus" @click="handleModal"></a-button>
                                </a-tooltip>
                            </span>
                        </a-col>

                        <a-col :md="5" :sm="24" style="float: right;">
                            <div style="display: flex; align-items: center;">
                                <span>8</span>
                                <a-slider style="width: 90%" v-model="sliderCount" reverse :max="8" :min="2" @change="handleSlider" />
                                <span>2</span>
                            </div>
                        </a-col>
                    </a-row>
                </a-form>
                
            </div>
            <a-spin :spinning="loading.list">
                <div class="forum-list" v-if="list.data && list.data.length > 0">
                    <div v-for="(item, idx) in list.data"
                        :style="`width: ${listItemWidth}px; height: ${listItemWidth}px;`"
                        :class="item.title ? 'has-title': 'no-title'"
                        :key="item.id">
                        <a-popconfirm :title="language['ispforum.delete.issue.confirm']"
                            :visible="delId === (item.topic_id ? item.topic_id : item.id)"
                            @visibleChange="handleDelVisibleChange"
                            @cancel="handleDelCancel"
                            @confirm="handleDelSubmit(item.topic_id ? item.topic_id : item.id)"
                            placement="top">
                            <div :style="{background: item.bgcolor || '#ffffff'}"
                                class="forum-list-item"
                                :class="(editId || delId) &&
                                    ((item.topic_id ? item.topic_id : item.id) === editId ||
                                    (item.topic_id ? item.topic_id : item.id) === delId)
                                    ? 'active'
                                    : ''"
                                @dblclick="handleDetail(item)">
                                <div class="forum-list-item-title"
                                    v-if="item.title">
                                    <a-tooltip :title="item.title" placement="topLeft">
                                        {{ item.title }}
                                    </a-tooltip>
                                </div>
                                <div class="forum-list-item-content">
                                    <span class="forum-list-item-date">
                                        <span v-html="item.created_at"></span>
                                        <span v-if="item.showImageIcon" v-html="item.imageIcon"></span>
                                    </span>
                                    <div style="height: 100%" v-html="item.pureContent"></div>
                                </div>
                                <div class="forum-list-item-action">
                                    <a-tooltip :title="language['ispforum.details']" placement="top">
                                        <a-icon type="message" @click="handleDetail(item)" style="color: #1890FF;" />
                                    </a-tooltip>
                                    <a-popover placement="bottom"
                                        trigger="click"
                                        :key="item.id"
                                        :arrowPointAtCenter="true"
                                        @visibleChange="handleTopicTagVisible(item)">
                                        <a-icon type="tag" style="color: #1890FF;" />
                                        <template slot="content">
                                            <a-spin :spinning="loading.tag">
                                                <div class="forum-tags">
                                                    <ul>
                                                        <a-checkbox-group @change="handleTopicTag" :value="tagChecked" v-if="tagsInfo.length > 0">
                                                            <li v-for="tag in tagsInfo" :key="tag.id">
                                                                <a-checkbox :value="tag.id"
                                                                    :disabled="tag.user_id !== userInfo.id">
                                                                    {{ tag.title }}
                                                                </a-checkbox>
                                                            </li>
                                                        </a-checkbox-group>
                                                        <a-empty v-else></a-empty>
                                                    </ul>
                                                    <div class="forum-tags-add">
                                                        <a-input :placeholder="language['ispforum.tags.name']" v-model="tagName" style="width: 160px;margin-right: 8px" :max-length="10" />
                                                        <a-tooltip :title="language['ispforum.tags.add']">
                                                            <a-button type="primary" icon="plus" @click="handleCreateTag(item.topic_id ? item.topic_id : item.id)"></a-button>
                                                        </a-tooltip>
                                                    </div>
                                                    <div class="forum-tags-manage">
                                                        <a-button type="primary"
                                                            icon="tags"
                                                            @click="handleTagsVisible"
                                                            ghost>{{ language['ispforum.tags.manage'] }}
                                                        </a-button>
                                                    </div>
                                                </div>
                                            </a-spin>
                                        </template>
                                    </a-popover>
                                    <a-tooltip :title="item.is_subscription ? language['ispforum.unsubscribe'] : language['ispforum.subscribe']" placement="top">
                                        <a-icon type="star" v-if="!item.is_subscription" @click="handleSubscription(item.topic_id ? item.topic_id : item.id, idx, 1)" style="color: #e9860f" />
                                        <a-icon type="star" theme="filled" @click="handleSubscription(item.topic_id ? item.topic_id : item.id, idx)" style="color: #e9860f" v-else />
                                    </a-tooltip>
                                    <a-popover title="選色板" trigger="click" placement="bottom">
                                        <template slot="content">
                                            <ul style="display: flex; list-style-type: none; padding: 8px 8px 0px 8px;">
                                                <li v-for="(bgColor, i) in bgColorList" :key="i">
                                                    <div :style="{background: bgColor}" class="forum-list-item-bg"  @click="handleBgColor(bgColor, item)"></div>
                                                </li>
                                            </ul>
                                        </template>
                                        <a-tooltip :title="language['ispforum.bgColor']" placement="top">
                                            <a-icon type="bg-colors"  style="color: #ff4d4d" />
                                        </a-tooltip>
                                    </a-popover>
                                    
                                    <a-dropdown :destroy-popup-on-hide="true"
                                        placement="bottomCenter"
                                        v-if="item.can_edit">
                                        <a-icon type="menu" style="color: #1890FF;" />
                                        <a-menu slot="overlay">
                                            <a-menu-item key="edit"
                                                @click="handleEdit(item.topic_id ? item.topic_id : item.id)">
                                                <a-icon type="edit" />{{ language['ispforum.edit'] }}
                                            </a-menu-item>
                                            <a-menu-item key="del" @click="delId = item.topic_id ? item.topic_id : item.id">
                                                <a-icon type="delete" />{{ language['ispforum.delete'] }}
                                            </a-menu-item>
                                        </a-menu>
                                    </a-dropdown>
                                </div>
                            </div>
                        </a-popconfirm>
                    </div>
                </div>
                <div class="forum-list-empty" v-else><a-empty /></div>
            </a-spin>
            <a-pagination :total="list.total"
                :page-size-options="pageSizeOptions"
                v-model="pagination.page"
                :page-size="pagination.pageSize"
                @showSizeChange="onShowSizeChange"
                @change="onPageChange"
                show-quick-jumper
                show-size-changer
                v-if="list.data && list.data.length > 0" />
        </a-card>
        <!-- 发表议题弹窗 -->
        <j-modal :visible="visible.topics"
            width="60%"
            :centered="true"
            :title="(editId ? language['ispforum.update'] : language['ispforum.post']) + language['ispforum.issue']"
            :maskClosable="false"
            @cancel="handleModal"
            @setInnerFullscreen="setInnerFullscreen"
            :wrap-class-name="innerFullscreen === false ? 'ispforum-modal' : null"
            :footer="null">
            <a-spin :spinning="editId && loading.update">
                <a-form-model class="form"
                    ref="forum-post-form"
                    :model="forumForm.validate"
                    :rules="forumForm.rules">
                    <a-row>
                        <a-col :span="24">
                            <a-form-model-item :label="language['ispforum.title']"
                                prop="title"
                                :labelCol="{span: 4}"
                                :wrapperCol="{span: 18}">
                                <a-input v-model="forumForm.validate.title" :max-length="100" :placeholder="language['ispforum.title.input']" />
                            </a-form-model-item>
                            <a-form-model-item :label="language['ispforum.content']"
                                prop="content"
                                :labelCol="{span: 4}"
                                :wrapperCol="{span: 18}">
                                <j-editor v-model="forumForm.validate.content"
                                    upload-source="ipsys"
                                    :limit="limitNum"></j-editor>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row class="form-row" type="flex" align="middle" justify="center" style="padding-bottom: 16px">
                        <a-button style="margin-right: 16px" @click="handleModal">{{ language['ispforum.cancel'] }}</a-button>
                        <a-button type="primary" @click="handlePost">
                            {{ editId ? language['ispforum.update'] : language['ispforum.post'] }}
                        </a-button>
                    </a-row>
                </a-form-model>
            </a-spin>
        </j-modal>
        <!-- 议题详情弹窗 -->
        <j-modal :visible="visible.detail"
            width="70%"
            :centered="true"
            :wrap-class-name="innerFullscreen === false ? 'ispforum-modal' : null"
            switchFullscreen
            :title="language['ispforum.issue.details']"
            :maskClosable="false"
            wrapClassName="detail-info"
            @cancel="handleDetail"
            @setInnerFullscreen="setInnerFullscreen"
            :footer="null">
            <a-spin :spinning="loading.discuss">
                <a-form-model class="form">
                    <a-row>
                        <a-col :span="24">
                            <a-form-model-item label="">
                                <a-input size="large" v-model="detailInfo.title" disabled readOnly />
                                <div class="detail-icons">
                                    <a-tooltip :title="detailInfo.is_subscription
                                        ? language['ispforum.unsubscribe']
                                        : language['ispforum.subscribe']"
                                        placement="top">
                                        <a-icon type="star"
                                            style="color: #e9860f"
                                            v-if="!detailInfo.is_subscription"
                                            @click="handleSubscription(detailInfo.id, 'detail', 1)" />
                                        <a-icon type="star"
                                            theme="filled"
                                            @click="handleSubscription(detailInfo.id, 'detail')"
                                            style="color: #e9860f" v-else />
                                    </a-tooltip>
                                    <a-popover placement="bottom"
                                        trigger="click"
                                        :key="detailInfo.id"
                                        :arrowPointAtCenter="true"
                                        @visibleChange="handleTopicTagVisible(detailInfo)">
                                        <a-icon type="tag" style="color: #1890FF;" />
                                        <template slot="content">
                                            <a-spin :spinning="loading.tag">
                                                <div class="forum-tags">
                                                    <ul>
                                                        <a-checkbox-group @change="handleTopicTag"
                                                            :value="tagChecked">
                                                            <li v-for="tag in tagsInfo" :key="tag.id">
                                                                <a-checkbox :value="tag.id">
                                                                    {{ tag.title }}
                                                                </a-checkbox>
                                                            </li>
                                                        </a-checkbox-group>
                                                    </ul>
                                                    <div class="forum-tags-add">
                                                        <a-input :placeholder="language['ispforum.tags.name']" :max-length="100" v-model="tagName" style="width: 160px;margin-right: 8px" />
                                                        <a-tooltip :title="language['ispforum.tags.add']">
                                                            <a-button type="primary" icon="plus" @click="handleCreateTag(detailInfo.id)"></a-button>
                                                        </a-tooltip>
                                                    </div>
                                                    <div class="forum-tags-manage">
                                                        <a-button type="primary"
                                                            icon="tags"
                                                            @click="handleTagsVisible"
                                                            ghost> {{ language['ispforum.tags.manage'] }}
                                                        </a-button>
                                                    </div>
                                                </div>
                                            </a-spin>
                                        </template>
                                    </a-popover>
                                    <a-tooltip :title="language['ispforum.issue.participate']" placement="top">
                                        <a-icon type="plus-circle" theme="filled" style="color: #1890ff" @click="handleTopicComment" />
                                    </a-tooltip>
                                    <a-tooltip v-if="detailInfo.user_id == userInfo.id && !detailInfo.is_gives && detailInfo.can_edit &&  (!detailInfo.commentslist || !detailInfo.commentslist.length) " :title="language['common.edit']" placement="top">
                                        <a-icon type="edit" style="color: #1890ff" @click="handleEdit(detailInfo.id, true)" />
                                    </a-tooltip>
                                </div>
                            </a-form-model-item>
                            <!-- 新增议题讨论 -->
                            <a-form-model-item label="" v-if="visible.comments">
                                <div class="detail-info-comment">
                                    <j-editor v-model="comment.content" upload-source="ipsys" :limit="5000" :height="200" ></j-editor>
                                    <div class="detail-info-comment-btns">
                                    <a-button type="primary" icon="check" @click="handleCreateOrUpdateComment"> {{ comment.isEdit ? language['ispforum.update'] : language['ispforum.post'] }} </a-button>
                                    <a-button icon="close" @click="handleTopicComment">{{ language['ispforum.cancel'] }}</a-button>
                                    </div>
                                </div>
                            </a-form-model-item>
                            <!-- 议题详细内容 -->
                            <a-form-model-item label="">
                                <div class="detail-info-item">
                                    
                                    <div class="detail-info-item-name0" style="width: 190px; flex-direction: column; ">
                                        <p v-html="detailInfo.nickname || detailInfo.sys_user_name"></p>
                                        <a-tooltip>
                                            <template slot="title">{{ detailInfo.created_at }}</template>
                                            <p class="date" v-html="detailInfo.created_at"></p>
                                        </a-tooltip>
                                    </div>

                                    <div class="detail-info-item-content" style="width: calc(100% - 264px)" v-html="detailInfo.content" @click="handleTopicContentClick"></div>
                                    <div class="detail-info-item-like" style="width: 64px;">
                                        <a-tooltip :title="language['ispforum.like']" v-if="!detailInfo.is_gives">
                                            <a-icon type="like"
                                                style="color: #f5222d;"
                                                @click="handleTopicAndCommentLike(1, detailInfo.id, 1)" />
                                        </a-tooltip>
                                        <a-tooltip :title="language['ispforum.unlike']" v-else>
                                            <a-icon type="like"
                                                @click="handleTopicAndCommentLike(1, detailInfo.id, 0)"
                                                style="color: #f5222d;"
                                                theme="filled" />
                                        </a-tooltip>
                                    </div>
                                </div>
                            </a-form-model-item>

                            <!-- 排序 -->
                            <a-form-model-item label="">
                                <div class="details-isorter" >
                                    <a-button 
                                        type="link"
                                        :style="{color: comment.orderSort == 'desc' ? ' #1890FF' : '#000000a6' }" 
                                        @click="(() => { comment.orderSort = 'desc'; handleCommentSort() })">
                                            {{ language['ispforum.publishedNewToOld'] }}
                                    </a-button>
                                    <a-divider type="vertical" />
                                    <a-button 
                                        type="link" 
                                        :style="{color: comment.orderSort == 'desc' ? '#000000a6' : ' #1890FF'}" 
                                        @click="(() => { comment.orderSort = 'asc'; handleCommentSort() })">
                                        {{ language['ispforum.publishedOldToNew'] }}
                                    </a-button>
                                </div>
                            </a-form-model-item>

                            <!-- 议题评论列表 -->
                            <a-form-model-item label="">

                                <div class="detail-info-items" v-if="commentsList && commentsList.length > 0">
                                    <div style="width: 100%; display: flex; flex-direction: column;"
                                        class="detail-info-item"> 
                                        <child-comment-iterate 
                                            :comment="commentsList"
                                            :handleTopicContentClick="handleTopicContentClick"
                                            :handleTopicAndCommentLike="handleTopicAndCommentLike"
                                            :handleCreateOrUpdateComment="handleCreateOrUpdateComment"
                                            :change="handleChildComments">
                                        </child-comment-iterate>
                                    </div>
                                </div>


                     
                                <a-empty class="detail-info-no-comments" :description="language['ispforum.comment.not']" v-else></a-empty>
                            </a-form-model-item>
                            <a-pagination
                                v-if="comment.total > 0"
                                :total="comment.total"
                                :page-size-options="pageSizeOptions"
                                v-model="comment.pagination.page"
                                :page-size="comment.pagination.pageSize"
                                @showSizeChange="onShowSizeChangeForComment"
                                @change="onPageChangeForComment"
                                show-quick-jumper
                                show-size-changer />
                        </a-col>
                    </a-row>
                </a-form-model>
            </a-spin>
        </j-modal>
        <!-- 标签管理弹窗 -->
        <a-modal v-model="visible.labels"
            :width="520"
            :z-index="1031"
            :mask-closable="false"
            wrap-class-name="tags-manage"
            :destroy-on-close="true"
            :footer="null"
            @cancel="tagManageCheckedObj = {}">
            <template slot="title">
                {{ language['ispforum.tags.manage'] }}
                <a-popconfirm :title="language['ispforum.tags.delete']"
                    :overlayStyle="{zIndex: 1040}"
                    @confirm="handleTopicTagRemove">
                    <a-button type="danger" style="margin-left: 16px">{{ language['ispforum.delete'] }}</a-button>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a-input v-model="tagManageCheckedObj.title" :max-length="100" :placeholder="language['ispforum.selectTagEdit']" style="width: 180px;"/>
                <a-button type="primary" style="margin-left: 8px" @click="handleTopicTagRevise" >{{ language['common.revise'] }}</a-button>
            </template>
            <a-spin :spinning="loading.tag" class="tags-manage-list">
                <ul>
                    <a-checkbox-group @change="handleTopicTagManage" v-model="tagManageChecked" v-if="tagsInfo.length > 0">
                        <li v-for="tag in tagsInfo" :key="tag.id">
                            <a-checkbox :value="tag.id" :disabled="tag.user_id !== userInfo.id">
                                {{ tag.title }}
                            </a-checkbox>
                        </li>
                    </a-checkbox-group>
                    <a-empty v-else></a-empty>
                </ul>
            </a-spin>
        </a-modal>
        <!-- 图片或视频弹窗 -->
        <j-modal :visible.sync="visible.media"
            width="80%"
            :centered="true"
            :wrap-class-name="innerFullscreen === false ? 'ispforum-modal' : null"
            :zIndex="1031"
            :title="language['ispforum.preview']"
            :mask-closable="true"
            :destroy-on-close="true"
            :footer="null"
            @setInnerFullscreen="setInnerFullscreen">
            <div class="ispforum-preview" v-html="preview"></div>
        </j-modal>
        <!-- 子评论弹窗 -->
        <a-modal
            :visible="commentVisible" 
            :destroy-on-close="true"
            :footer="null"
            :closable="false">

            <div class="detail-info-comment">
                <j-editor v-model="childCommentObj.content2" ></j-editor>

                <div class="detail-info-comment-btns">
                    
                    <a-button 
                        type="primary" 
                        icon="check" 
                        @click="((e) => { handleCreateOrUpdateComment(childCommentObj.pid, childCommentObj.content2, () => {
                                                commentVisible = false; 
                                                childCommentObj.content2 = null; 
                                                this.$forceUpdate(); } )})">
                        {{ language['ispforum.post'] }}
                    </a-button>
                    <a-button icon="close" 
                        @click="(() => { commentVisible = false; 
                                    childCommentObj.content2 = null; 
                                    this.$forceUpdate();})">
                        {{ language['ispforum.cancel'] }}
                    </a-button>
                </div>
            </div>
        </a-modal>
    </a-row>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from '@/api/manageExtend'
import JEditor from './Editor'
import Comment from './Comment'
import ImageIcon from '@assets/image.svg'
import JModal from '@/components/jeecg/JModal/JModal.vue'

const imgReg = /<img.*?(?:>|\/>)/gi
const videoReg = /<video.*?(?:>|\/>)/gi

// 评论迭代布局
const ChildCommentIterate = {
    props: ['comment', 'handleTopicContentClick', 'handleTopicAndCommentLike', 'handleCreateOrUpdateComment', 'change'],
    computed: {
        language() {
            return this.$store.getters.language
        },
    },

    methods: {
        iterateComment(comment) {
            if (comment.child && comment.child.length) {
                return (
                    <ChildCommentIterate 
                        comment={comment.child}
                        handleTopicContentClick={this.handleTopicContentClick}
                        handleTopicAndCommentLike={this.handleTopicAndCommentLike}
                        handleCreateOrUpdateComment={this.handleCreateOrUpdateComment}
                        change={this.change}>
                    </ChildCommentIterate>
                )
            }                               
        },

        showCommentMoaal(comment) {
            this.change(true, comment.id)
        },
    },

    render() {
        const { comment } = this;
        if (comment && comment.length) {
            return (
                <div style={{width: '100%'}}>
                {
                    comment.map((childComment, index) => {
                        return <ul style={{'padding-left': '14px'}}>
                                    <li style={{display: 'flex', 'flex-direction': 'column', 'list-style': 'none', 'padding-bottom': '8px'}}>
                                        <div style={{width: '100%', 'padding-bottom': '16px', display: 'flex', 'flex-direction': 'column'}}>
                                            

                                            <div class={['detail-info-item-name']}>
                                                <p domPropsInnerHTML={childComment.pid == 0 ? childComment.nickname || childComment.sys_user_name : childComment.user_info.nickname || childComment.user_info.sys_user_name}></p>
                                                <a-tooltip>
                                                    <template slot="title">{ childComment.created_at }</template>
                                                    <p class={['date']} domPropsInnerHTML={childComment.created_at}></p>
                                                </a-tooltip>
                                            </div>

                                            <div style={{display: 'flex'}}>
                                                <div class={['detail-info-item-content']}
                                                    domPropsInnerHTML={childComment.content}  
                                                    onClick={() => this.handleTopicContentClick}
                                                    >
                                                </div>

                                                <div style={{width: '60px', display: 'flex', 'justify-content': 'center', 'align-self': 'center'}}>
                                                        
                                                        {
                                                            !childComment.is_gives ?
                                                            <a-tooltip title={this.language['ispforum.like']}>
                                                                <a-icon 
                                                                    type="like" 
                                                                    style={{color:'#f5222d', 'font-size': '18px', 'align-items': 'center', 'justify-content': 'center', 'padding-left': '40px'}}
                                                                    onClick={(e) => this.handleTopicAndCommentLike(2, childComment.id, 1, index)} />
                                                            </a-tooltip>
                                                            :
                                                            <a-tooltip title={this.language['ispforum.unlike']}>
                                                                <a-icon 
                                                                    type="like"
                                                                    onClick={(e) => this.handleTopicAndCommentLike(2, childComment.id, 0, index)}
                                                                    style={{color: '#f5222d', 'font-size': '18px', 'align-items': 'center', 'justify-content': 'center', 'padding-left': '40px'}}
                                                                    theme="filled" />
                                                            </a-tooltip>
                                                        }
                                                         <a-icon type="plus-circle" onClick={ () => this.showCommentMoaal(childComment, index)} theme="filled" style={{'padding-left': '16px', color: '#1890ff', 'font-size': '18px'}} />
                                                </div>
                                            </div>

                                            
                                        </div>

                                        { this.iterateComment(childComment) }
                                    </li>
                                </ul>
                    })
                }
                </div>
            )
        }
    }
}


export default {
    name: 'All',
    components: { JEditor, JModal, Comment, ChildCommentIterate },
    props: {
        type: String,
    },
    computed: {
        language() {
            return this.$store.getters.language
        },
    },
    data() {
        return {
            // 预览 ( 图片 / 视频 )
            preview: null,

            // 议题内容 / 评论内容字数限制
            limitNum: 5000,

            // 加载中状态 ...
            loading: {
                list: false,
                update: false,
                delete: false,
                discuss: false,
                comment: false,
                remove: false,
                tag: false,
                like: false
            },
            
            // 显隐状态
            visible: {
                topics: false,
                detail: false,
                comments: false,
                childComment: false,
                tags: false,
                labels: false,
                media: false,
            },

            // 评论相关
            comment: {
                tid: 0,
                isEdit: false,
                editId: 0,
                info: {},
                total: 0,
                orderBy: 'created_at',
                orderSort: 'desc',
                pagination: {
                    page: 1,
                    pageSize: 10
                }
            },

            // 标签过滤
            searchTag: 0,

            // 新增标签名称
            tagName: null,

            // 议题选中标签
            tagChecked: [],

            // 标签管理中选中值
            tagManageChecked: [],
            
            // 标签管理中最后选中的对象
            tagManageCheckedObj: {},

            // 展示中的标签所对应的议题ID
            tagShowingTopicId: 0,

            // 用户信息
            userInfo: {},

            // 议题详情
            detailInfo: {},

            // 评论列表
            commentsList: {},

            // 单个议题的标签列表
            tagsInfo: [],

            // 编辑项目ID
            editId: null,

            // 是否更新详情， 用于在详情编辑信息后
            isUpdateDetail: false,

            // 编辑议题的内容
            editInfo: {},

            // 待删除ID
            delId: null,

            // 议题搜索参数
            queryParams: {
                keyword: null
            },
            
            // 列表数据
            list: {
                total: 0,
                data: []
            },

            // 列表分页
            pagination: {
                page: 1,
                pageSize: 20
            },

            // 分页条数
            pageSizeOptions: ['10', '20', '30', '40', '50', '100'],

            // 议题表单数据
            forumForm: {
                validate: {
                    title: null,
                    content: null
                },
                rules: {content: [{
                    required: true,
                    message: this.$store.getters.language['ispforum.issue.content.input'],
                    trigger: 'blur'
                }]}
            },

            // 过滤筛选当前用户的议题
            isMine: 0,

            // 弹窗相关
            modal: {
                width: '80%',
                height: '80%'
            },

            // 实时屏幕宽度
            windowWidth: document.documentElement.clientWidth,  
            
            // modal 是否全屏放大
            innerFullscreen: false,
            
            // 列表背景颜色
            bgColorList: ['#ffffff', '#ed1c24', '#f97d1c', '#fbda41', '#12a182', '#96c24E', '#99d9ea', '#1172b4', '#3e48cc', '#681752', '#a762e6'],

            commentVisible: false,

            childCommentObj: {},

            // 排列个数
            sliderCount: 3,
            // ant-card-body 宽度
            cardBodyWidth: 0,
            // 列表 item 宽度
            listItemWidth: 0,
            // 存储的key
            sessionKey: 'SessionKey',
        }
    },
    created() {
        this.handleList()
        this.userInfo = this.$store.getters.userInfo
        console.log('this.userInfo = ', this.userInfo)

        // this.sessionKey = this.type + 'SessionKey'
        let count = sessionStorage.getItem(this.sessionKey)
        console.log('count = ', count)
        if (!count) {
            this.sliderCount = this.windowWidth >= 1600 ? 5 : this.windowWidth >= 1200 ? 4 : 3
        } else {
            this.sliderCount = count
        }
        this.sliderCount = Number(this.sliderCount)
        this.$nextTick(() => {
            setTimeout(() => {
                this.cardBodyWidth = document.getElementsByClassName('list')[0].offsetWidth - 48
                this.listItemWidth = this.cardBodyWidth / this.sliderCount
                sessionStorage.setItem(this.sessionKey, this.sliderCount)
            }, 0.1); 
        })   
    },
    methods: {
        // 议题 ( 热门/订阅/参加 )
        getTopics(api = '/v1/hots') {
            if (this.loading.list) return
            this.loading.list = true
            getAction(api, {
                ...this.pagination,
                ...this.queryParams
            }).then((res) => {
                this.loading.list = false
                if (res.code === 200) {
                    this.list.total = res.result.total
                    this.list.data = res.result.data
                    for (let i = 0, l = this.list.data.length; i < l; i++) {
                        this.setFilterTags(i)
                    }
                } else this.$message.error(res.message)
            }).catch((err) => {
                this.loading.list = false
                this.$message.error(err)
            })
        },

        // 议题列表
        getList(searchTag = false, skipLoading = false) {
            if (!skipLoading && this.loading.list) return
            if (!skipLoading) this.loading.list = true
            if (this.type === 'mine') this.isMine = 1
            const params = {
                ...this.queryParams,
                ...this.pagination
            }
            if (this.isMine) params.is_user = this.isMine
            if (
                searchTag ||
                this.searchTag
            ) params.tagId = Array.isArray(searchTag) ? searchTag.join(',') : this.searchTag
            getAction('/v1/topics', params).then((res) => {
                this.loading.list = false
                if (res.code === 200) {
                    this.list.total = res.result.total
                    this.list.data = res.result.data
                    for (let i = 0, l = this.list.data.length; i < l; i++) {
                        this.setFilterTags(i)
                    }
                } else this.$message.error(res.message)
            }).catch((err) => {
                this.loading.list = false
                this.$message.error(err)
            })
        },

        // 过滤标签
        setFilterTags(i) {
            // 过滤标签
            let pureContent = this.list.data[i].content.replace(/<[^>]+>/g, '').replace(/&nbsp;/ig, '').trim()
            // 图片/视频显示处理
            this.list.data[i].showImageIcon = false
            this.list.data[i].imageIcon = ''
            // const videoReg = /<video.*?(?:>|\/>)/gi
            const imgs = this.list.data[i].content.match(imgReg)
            // const videos = this.list.data[i].content.match(videoReg)
            if (imgs && imgs.length > 0) {
                // 存在图片
                if (pureContent.length > 0) {
                    // 图片与文字同时存在，显示图片 ICON
                    this.list.data[i].showImageIcon = true
                    this.list.data[i].imageIcon = `<img src="${ImageIcon}" />`
                    pureContent = pureContent.substr(0, 52) + ' ...'
                } else {
                    // 内容仅是图片，则显示第一张图片的缩略图
                    pureContent = imgs[0]
                }
            }
            this.list.data[i].pureContent = pureContent
        },

        // 部门议题
        getDepartmentList() {
            this.getTopics('/v1/topics/department')
        },

        // 热门议题
        getHotList() {
            this.getTopics()
        },

        // 我订阅的
        getSubscriptionList() {
            this.getTopics('/v1/topics/subscription')
        },

        // 我参加的
        getParticipageList() {
            this.getTopics('/v1/topics/participate')
        },

        // 议题详情
        getTopicDetail(topic_id) {
            topic_id = topic_id ? topic_id : this.comment.tid
            if (topic_id) {
                if (this.loading.discuss) return
                this.loading.discuss = true
                getAction(`/v1/topic/${topic_id}`).then((res) => {
                    this.loading.discuss = false
                    if (res.code === 200) {
                        this.detailInfo = res.result
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.discuss = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.issue.id.incorrect'])
        },

        // 议题评论
        getTopicComments(topic_id, isInit) {
            console.log('进来了')
            topic_id = topic_id ? topic_id : this.comment.tid
            if (topic_id) {
                if (!isInit && this.loading.discuss) return
                console.log('进来了2')
                this.loading.discuss = true
                getAction('/v1/comment', {
                    topic_id,
                    orderBy: this.comment.orderBy,
                    orderSort: this.comment.orderSort,
                    ...this.comment.pagination
                }).then((res) => {
                    this.loading.discuss = false
                    if (res.code === 200) {
                        this.commentsList = res.result.data
                        this.comment.total = res.result.total
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.discuss = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.issue.id.incorrect'])
        },

        // 所有标签
        getTags(tid = 0, listLoading = true, isDeleteFinish = false) {
            tid = tid ? tid : this.tagShowingTopicId
            if (this.loading.tag) return
            this.loading.tag = true
            if (listLoading) this.loading.list = true
            getAction('/v1/tags', {
                page: 1,
                pageSize: 10000
            }).then((res) => {
                this.loading.tag = false
                const tags = []
                if (res.code === 200) {
                    this.$set(this, 'tagsInfo', res.result.data || [])
                    // 议题标签
                    if (tid && tid !== -1) this.getTopicTag(tid)
                    // 根据标签获取议题
                    if (tid === -1 || isDeleteFinish) {
                        for (let i = 0, l = this.tagsInfo.length; i < l; i++) {
                            tags.push(this.tagsInfo[i].id)
                        }
                        if (tags.length > 0) {
                            this.getList(tags, true)
                        } else  {
                            this.loading.tag = false
                            if (listLoading) this.loading.list = false
                        }
                        
                    } else {
                        if (listLoading) this.loading.list = false
                    }
                } else {
                    if (listLoading) this.loading.list = false
                    this.$message.error(res.message)
                }
                if (isDeleteFinish && tags.length <= 0) {
                    this.list.total = 0
                    this.list.data = []
                }
            }).catch((err) => {
                this.loading.tag = false
                if (listLoading) this.loading.list = false
                this.$message.error(err)
            })
        },

        // 议题标签
        getTopicTag(topic_id) {
            topic_id = topic_id ? topic_id : this.tagShowingTopicId
            if (topic_id) {
                if (this.loading.tag) return
                this.loading.tag = true
                getAction('/v1/topictags', {
                    topic_id
                }).then((res) => {
                    this.loading.tag = false
                    this.tagShowingTopicId = topic_id
                    if (res.code === 200) {
                        const list = res.result
                        const checked = []
                        for (let i = 0, l = list.length; i < l; i++) {
                            checked.push(list[i].id)
                        }
                        this.$set(this, 'tagChecked', checked)
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.tag = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.issue.id.incorrect.tags'])
        },

        // 控制列表
        handleList() {
            console.log('进来了')
            switch(this.type) {
                case 'tags':
                    this.getTags(-1)
                    break
                case 'hot':
                    this.getHotList()
                    break
                case 'department':
                    this.getDepartmentList()
                    break
                case 'participate':
                    this.getParticipageList()
                    break
                case 'subscription':
                    this.getSubscriptionList()
                    break
                default:
                    this.getList()
                    break
            }
        },

        // 议题标签列表显隐
        handleTopicTagVisible(item) {
            this.visible.tags = !this.visible.tags
            if (this.visible.tags) this.getTags(item.topic_id ? item.topic_id : item.id, false)
            else this.tagShowingTopicId = 0
        },

        // 更新议题标签
        handleTopicTag(checkedValue) {
            this.$set(this, 'tagChecked', checkedValue)
            if (this.loading.tag) return
            this.loading.tag = true
            postAction('/v1/addtags', {
                topic_id: this.tagShowingTopicId,
                tag_id: checkedValue.join(',')
            }).then((res) => {
                this.loading.tag = false
                if (this.type === 'tags') this.handleList()
                if (res.code !== 200) this.$message.error(res.message)
            }).catch((err) => {
                this.loading.tag = false
                this.$message.error(err)
            })
        },

        // 标签管理
        handleTopicTagManage(checkedValue) {
            this.tagManageChecked = checkedValue

            const tagObjList = this.tagsInfo.filter((tag => {
                if (tag.id === checkedValue[checkedValue.length - 1]) {
                    return tag
                }
            }))
            this.tagManageCheckedObj = tagObjList.length ? {...tagObjList[tagObjList.length - 1]}  : {}
            console.log('this.tagManageCheckedObj = ', this.tagManageCheckedObj)
       },

        // 标签搜索
        handleTagChange() {
            if (this.searchTag) this.getList(true)
            else this.handleList()
        },

        // 标签管理 - 移除标签
        handleTopicTagRemove() {
            if (this.tagManageChecked.length > 0) {
                if (this.loading.tag) return
                this.loading.tag = true
                deleteAction(`/v1/tag/${this.tagManageChecked.join(',')}`).then((res) => {
                    this.loading.tag = false
                    if (res.code === 200) {
                        this.$message.success(this.language['ispforum.delete.success'])
                        this.tagManageChecked = []
                        console.log('this.loading.tag =', this.loading.tag)
                        this.getTags(false, false, true)
                        this.$nextTick(() => this.$forceUpdate())
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.tag = false
                    this.$message.error(err)
                })
            } else this.$message.warning(this.language['ispforum.tags.delete.select'])
        },

        // 标签管理 - 修改标签
        handleTopicTagRevise() {
            if (this.tagManageChecked.length > 0) {
                if (this.loading.tag) return
                this.loading.tag = true
                
                putAction('/v1/tag', this.tagManageCheckedObj).then((res) => {
                    this.loading.tag = false
                    if (res.code === 200) {
                        this.$message.success(this.language['common.editSuccess'])
                        this.tagManageChecked = []
                        console.log('this.loading.tag =', this.loading.tag)
                        this.getTags(false, false)
                        this.$nextTick(() => this.$forceUpdate())
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.tag = false
                    this.$message.error(err)
                })
            } else this.$message.warning(this.language['ispforum.selectTagEdit'])
        },

        // 议题详情
        handleDetail(item) {
            this.innerFullscreen = false
            this.visible.detail = !this.visible.detail
            // 重置评论列表的分页
            this.comment.pagination.page = 1
            this.comment.pagination.pageSize = 10
            if (this.visible.detail) {
                // 显示
                this.detailInfo = item
                const tid = item.topic_id ? item.topic_id : item.id
                this.comment.tid = tid
                this.getTopicDetail(tid)
                this.getTopicComments(tid, true)
            } else {
                this.detailInfo = {}
                this.visible.comments = false
            }
        },

        // 评论排序
        handleCommentSort() {
            // 重置评论列表的分页
            this.comment.pagination.page = 1
            this.comment.pagination.pageSize = 10
            this.getTopicComments()
        },

        // 点击议题详情 ( 处理图片 )
        handleTopicContentClick(evt) {
            const target = evt.target
            const tagName = target.tagName
            if (
                tagName &&
                (
                    tagName.toUpperCase() === 'IMG' ||
                    tagName.toUpperCase() === 'VIDEO'
                )
            ) {
                this.visible.media = true
                const src = target.src
                if (tagName.toUpperCase() === 'IMG') this.preview = `<img src=${src} />`
                if (tagName.toUpperCase() === 'VIDEO') this.preview = `<video src=${src} control autoplay />`
            }
        },

        // 议题评论
        handleTopicComment() {
            this.visible.comments = !this.visible.comments
            if (!this.visible.comments) {
                if (this.comment.isEdit) {
                    this.comment.isEdit = false
                    this.comment.editId = 0
                    this.comment.content = null
                }
            }
        },

        // 评论编辑状态设置
        handleUpdateCommentState(id, content) {
            if (id) {
                this.visible.comments = true
                this.comment.isEdit = true
                this.comment.editId = id
                this.comment.content = content
            } else this.$message.error(this.language['ispforum.comment.id.incorrect'])
        },

        // 新增评论
        handleCreateOrUpdateComment(pid, newContent, callback) {
            console.log('pid = ', pid)
            console.log('newContent = ', newContent)
            if (this.detailInfo.id) {
                newContent = newContent ? newContent : this.comment.content
                const imgs = newContent.match(imgReg)
                const videos = newContent.match(videoReg)
                let content = newContent.replace(/<[^>]+>/ig, '')
                content = content.replace(/&nbsp;/ig, '').trim()
                if (
                    content ||
                    (imgs && imgs.length > 0) ||
                    (videos && videos.length > 0)
                ) {
                    if (this.loading.comment) return 
                    this.loading.comment = true
                    if (this.comment.isEdit) {
                        if (this.comment.editId) {
                            // 更新
                            let params = { topic_id: this.detailInfo.id, content: newContent }
                            if (pid && Object.prototype.toString.call(pid) === '[object Number]') params.pid = pid
                            putAction(`/v1/comment/${this.comment.editId}`, params).then((res) => {
                                this.loading.comment = false
                                if (res.code === 200) {
                                    this.comment.content = null
                                    this.$message.success(this.language['ispforum.update.success'])
                                    this.detailInfo.can_edit = false
                                    if (!callback) {
                                        console.log('12342')
                                        this.handleTopicComment()
                                    }
                                    this.getTopicComments(this.detailInfo.id)
                                    // 更新列表
                                    this.handleList()
                                    // 回调
                                    if (typeof callback === 'function') {
                                        callback()
                                    }
                                } else this.$message.error(res.message)
                            }).catch((err) => {
                                this.loading.comment = false
                                this.$message.error(err)
                            })
                        } else {
                            this.loading.comment = false
                            this.$message.error(this.language['ispforum.comment.id.incorrect'])
                        }
                    } else {
                        // 发布
                        let params = { topic_id: this.detailInfo.id, content: newContent }
                        if (pid && Object.prototype.toString.call(pid) === '[object Number]') params.pid = pid
                        postAction('/v1/comment', params).then((res) => {
                            this.loading.comment = false
                            if (res.code === 200) {
                                this.comment.content = null
                                this.$message.success(this.language['ispforum.post.success'])
                                this.detailInfo.can_edit = false
                                if (!callback) {
                                    this.handleTopicComment()
                                }
                                this.getTopicComments(this.detailInfo.id)
                                // 更新列表
                                this.handleList()
                                // 回调
                                if (typeof callback === 'function') {
                                    callback()
                                }
                            } else this.$message.error(res.message)
                        }).catch((err) => {
                            this.loading.comment = false
                            this.$message.error(err)
                        })
                    }
                } else this.$message.error(this.language['ispforum.comment.input'])
            } else this.$message.error(this.language['ispforum.issue.id.incorrect'])
        },

        // 删除评论
        handleDeleteComment(id) {
            if (id) {
                if (this.loading.remove) return
                this.loading.remove = true
                deleteAction(`/v1/comment/${id}`).then((res) => {
                    this.loading.remove = false
                    if (res.code === 200) {
                        this.$message.success(this.language['ispforum.delete.success'])
                        this.getTopicComments()
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.remove = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.comment.id.incorrect'])
        },

        // 控制发表议题弹窗的显隐
        handleModal() {
            this.visible.topics = !this.visible.topics
            this.editId = null
            this.editInfo = {}
            this.forumForm.validate.title = null
            this.forumForm.validate.content = null
        },

        // 议题搜索
        handleSearch() {
            this.pagination.page = 1
            this.handleList()
        },

        // 搜索内容变化 ( 监听为空时获取全部内容 )
        handleSearchChange(evt) {
            const v = evt.target.value
            if (!v) this.handleList()
        },

        // 控制删除确认框的隐藏 ( 点击其他区域时 )
        handleDelVisibleChange(visible) {
            if (!visible) this.handleDelCancel()
        },

        // 发表议题
        handlePost() {
            this.$refs['forum-post-form'].validate((valid) => {
                if (valid) {
                    const imgs = this.forumForm.validate.content.match(imgReg)
                    const videos = this.forumForm.validate.content.match(videoReg)
                    let content = this.forumForm.validate.content.replace(/<[^>]+>/ig, '')
                    content = content.replace(/&nbsp;/ig, '').trim()
                    // 无文本内容
                    if (content.length <= 0) {
                        // 同时也没有媒体信息
                        if (imgs.length <= 0 && videos.length <= 0) {
                            this.$message.error(this.language['ispforum.issue.content.input'])
                            return
                        }
                    }
                    if (content.length > this.limitNum) {
                        this.$message.error(this.language['ispforum.limit.start'] + ` ${this.limitNum} ` + this.language['ispforum.limit.end'])
                        return
                    }
                    if (this.loading.list) return
                    this.loading.list = true
                    if (this.editId) {
                        // 更新
                        this.loading.update = true
                        putAction(`/v1/topic/${this.editId}`, {
                            ...this.forumForm.validate,
                            status: 1
                        }).then((res) => {
                            this.loading.update = false
                            this.loading.list = false
                            if (res.code === 200) this.handleAfterPostOrEdit(true)
                            else this.$message.error(res.message)
                        }).catch((err) => {
                            this.loading.update = false
                            this.loading.list = false
                            this.$message.error(err)
                        })
                    } else {
                        // 发布
                        postAction('/v1/topic', {
                            ...this.forumForm.validate
                        }).then((res) => {
                            this.loading.list = false
                            if (res.code === 200) this.handleAfterPostOrEdit()
                            else this.$message.error(res.message)
                        }).catch((err) => {
                            this.loading.list = false
                            this.$message.error(err)
                        })
                    }
                }
            })
        },

        // 发布/编辑成功后的处理
        handleAfterPostOrEdit(edit = false) {
            console.log('isUpdateDetail = ', this.isUpdateDetail)
            if (this.isUpdateDetail) {
                this.getTopicDetail(this.editId)
            }
            this.pagination.page = 1
            this.handleList()
            this.handleModal()
            this.$message.success(edit ? this.language['ispforum.update.success'] : this.language['ispforum.post.success'])
            if (edit) this.editId = null
        },

        // 编辑议题
        handleEdit(id, isUpdateDetail = false) {
            if (id) {
                this.handleModal()
                this.editId = id
                this.isUpdateDetail = isUpdateDetail
                this.loading.update = true
                getAction(`/v1/topic/${id}`).then((res) => {
                    this.loading.update = false
                    if (res.code === 200) {
                        this.editInfo = res.result
                        this.forumForm.validate.title = res.result.title
                        this.forumForm.validate.content = res.result.content
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.update = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.issue.id.incorrect'])
        },

        // 删除确认框的确认操作
        handleDelSubmit(id) {
            if (id) {
                if (this.loading.delete) return
                this.loading.delete = true
                deleteAction(`/v1/topic/${id}`).then((res) => {
                    this.loading.delete = false
                    if (res.code === 200) {
                        this.$message.success(this.language['ispforum.delete.success'])
                        this.pagination.page = 1
                        this.handleList()
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.delete = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispfourm.issue.id.incorrect.tags'])
            this.handleDelCancel()
        },

        // 订阅/取消订阅议题
        handleSubscription(tid, idx, status = 0) {
            if (tid) {
                if (this.loading.list) return
                this.loading.list = true
                getAction(`/v1/subscription`, {
                    topic_id: tid,
                    status
                }).then((res) => {
                    this.loading.list = false
                    if (res.code === 200) {
                        this.$message.success(status ? this.language['ispforum.subscribe.success'] : this.language['ispforum.unsubscribe.success'])
                        if (idx === 'detail') {
                            // 更新详情值
                            this.detailInfo.is_subscription = status ? true : false
                        } else {
                            // 更新列表值
                            if (
                                this.type === 'subscription' &&
                                status === 0
                            ) {
                                this.pagination.page = 1
                                this.getSubscriptionList()
                            } else this.list.data[idx].is_subscription = status ? true : false
                        }
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.list = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.issue.id.incorrect.opt'])
        },

        // 新增标签
        handleCreateTag(id) {
            if (id) {
                if (this.loading.tag) return
                this.loading.tag = true
                postAction('/v1/tag', {
                    data: [{
                        title: this.tagName
                    }]
                }).then((res) => {
                    this.loading.tag = false
                    if (res.code === 200) {
                        this.$message.success(this.language['ispforum.tags.add.success'])
                        this.getTags(false, false)
                        this.tagName = null
                    } else this.$message.error(res.message)
                }).catch((err) => {
                    this.loading.tag = false
                    this.$message.error(err)
                })
            } else this.$message.error(this.language['ispforum.issue.id.incorrect'])
        },

        // 标签管理弹窗
        handleTagsVisible() {
            this.visible.labels = !this.visible.labels
            this.tagManageChecked = []
            if (this.visible.labels) this.getTags(false, false)
        },

        // 议题&评论点赞/取消点赞
        handleTopicAndCommentLike(type, id, status, idx) {
            if (!idx) idx = 0;
            if (id) {
                if (type === 1 || type === 2) {
                    if (this.loading.like) return
                    this.loading.like = true
                    getAction('/v1/gives', {
                        type,
                        type_id: id,
                        status
                    }).then((res) => {
                        this.loading.like = false
                        if (res.code === 200) {
                            this.$message.success(this.language['ispforum.opt.success'])
                            if (type === 1) this.detailInfo.is_gives = status ? true : false
                            if (type === 2) this.commentsList[idx].is_gives = status ? true : false
                            this.getList()
                        } else this.$message.error(res.message)
                    })
                } else this.$message.error(this.language['ispforum.type.incorrect'])
            } else this.$message.error(this.language['ispforum.issue.comment.id.incorrect'])
        },

        // 控制确认框的取消操作
        handleDelCancel() {
            this.delId = null
        },

        // 分页条数变化事件监听
        onShowSizeChange(_current, pageSize) {
            this.pagination.page = 1
            this.pagination.pageSize = pageSize
            this.handleList()
        },

        // 分页变化事件监听
        onPageChange(cur) {
            this.pagination.page = cur
            this.handleList()
        },

        // 分页条数变化事件监听
        onShowSizeChangeForComment(_current, pageSize) {
            // 重置回第一页
            this.comment.pagination.page = 1
            this.comment.pagination.pageSize = pageSize
            this.getTopicComments()
        },

        // 分页变化事件监听
        onPageChangeForComment(cur) {
            this.comment.pagination.page = cur
            this.getTopicComments()
        },

        // modal 放大缩小回调
        setInnerFullscreen(val) {
            this.innerFullscreen = val
            console.log('this.innerFullscreen = ', this.innerFullscreen)
        },

        // 点击选择色板 背景色
        handleBgColor(bgColor, item) {
            if (this.loading.list) {
                return
            }
            item.bgcolor = bgColor
            console.log('item = ', item)
            console.log('list = ', this.list.data)
            this.$forceUpdate()
            this.loading.list = true
            putAction(`/v1/bg/${item.id}`, {bgcolor: bgColor}).then(res => {
                console.log('res = ', res)
                if (res.code !== 200) {
                    this.$message.error(res.message)
                }
            }).finally(() => this.loading.list = false )
        },

        // 子评论
        handleChildComments(visible, pid) {
            this.commentVisible = visible; 
            console.log('visible = ', visible);
            console.log('pid = ', pid);
            this.childCommentObj.pid = pid;
        },

        handleSlider(val) {
            this.listItemWidth = this.cardBodyWidth / this.sliderCount
            sessionStorage.setItem(this.sessionKey, this.sliderCount)
        },
    },
    mounted() {
        var that = this;
        // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                that.$nextTick(() => {
                    setTimeout(() => {
                        that.cardBodyWidth = document.getElementsByClassName('list')[0].offsetWidth - 48
                        that.listItemWidth = that.cardBodyWidth / that.sliderCount
                    }, 1); 
                })

            })()
        };
    },

}
</script>

<style lang="less" scoped>

.table-page-search-wrapper .table-page-search-submitButtons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.tinymce-editor {
    width: 100%;
}

/deep/ .ispforum-modal {
    .ant-modal-body {
        max-height: calc(100vh - 160px);
        overflow: auto;
    }
}

/deep/ .forum-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-direction: row;

    // > div {
    //     width: calc(100% / 5);
    // }

    &-empty {
        justify-content: center;
        padding: 24px;
    }

    &-item {
        width: calc(100% - 16px);
        // height: 192px;
        height: 95%;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        margin-right: 16px;
        margin-bottom: 16px;
        padding: 12px;
        transition: all .3s ease;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        
        &:hover {
            box-shadow: 0 0 10px #d9d9d9;
        }

        &-bg {
            width: 44px;
            height: 44px;
            border: 1px solid #d9d9d9;
        }

        &-title {
            color: #333;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 4px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 100%;
        }

        &-content {
            max-height: 80%;
            overflow: hidden;
            scrollbar-width: none;
            -ms-overflow-style: none;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            border-radius: 0 0 4px 4px;

            > div {
                display: flex;
                align-items: flex-start;
                justify-content: center;
            }

            > div img,
            > div video {
                max-width: 100%;
                // height: auto;
                // height: 100%;
                height: calc(100% - 25px);
                object-fit: contain;
                border-radius: 4px;
            }
        }

        &-date {
            color: #bcbcbc;
            margin-right: 8px;
            margin-bottom: 4px;
            display: flex;
            align-items: center;
            justify-content: center;

            > span {
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:last-child {
                    margin-right: 0;
                }

                img {
                    width: 20px;
                }
            }
        }

        &-action {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 12px 0;

            i.anticon {
                font-size: 20px;
                margin-right: 18px;
            }
        }

        &.active {
            border-color: #1890FF;
            box-shadow: 0 0 10px #1890FF;
        }
    }

    .has-title {
        .forum-list-item-content {
            height: calc(~'100% - 68px');;
        }
    }

    .no-title {
        .forum-list-item-content {
            height: calc(~'100% - 25px');;
        }
    }

    

    .screenWidth5 {
        width: calc(100% / 5);
    }

    .screenWidth4 {
    width: calc(100% / 4);
}

    .screenWidth3 {
        width: calc(100% / 3);
    }
}

/deep/ .ispforum-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px;

    img,
    video {
        object-fit: cover;
        max-width: 96%;
        border-radius: 4px;
        box-shadow: 0 0 10px #a2a2a2;
    }
}

.ant-pagination {
    padding: 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.forum-tags {
    width: 200px;

    ul {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        margin: 0;
        padding: 8px;
        max-height: 200px;
        overflow-x: hidden;
        overflow-y: auto;
        border: 1px solid #ebebeb;
        border-radius: 4px;
        margin-bottom: 16px;

        li {
            list-style: none;
            margin-bottom: 12px;

            &:last-child {
                margin-bottom: 0
            }
        }
    }

    &-add {
        width: 200px;
    }

    &-manage {
        margin-top: 16px;

        button {
            width: 100%;
        }
    }
}

.tags-manage-list {
    ul {
        margin: 0;
        padding: 16px;
        max-height: 240px;
        border: 1px solid #ececec;
        border-radius: 4px;
        overflow-x: hidden;
        overflow-y: auto;

        li {
            margin-bottom: 8px;
            list-style: none;
        }
    }
}

/deep/ .ant-form-item-children {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .ant-input {
        line-height: 28px;
        font-size: 16px;
        color: #333;
        letter-spacing: 1px;
    }

    .detail-info-no-comments {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .detail-icons {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 16px;

        i {
            font-size: 18px;
            margin-right: 16px;
            cursor: pointer;

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .detail-info-items {
        border: 1px solid #ebebeb;
        border-radius: 4px;
        padding: 16px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        width: 100%;
        overflow: auto;
    }

    .detail-info-items .detail-info-item {
        // padding-bottom: 24px;
        border-bottom: 1px solid #f7f7f7;

        &:last-child {
            padding-bottom: 0;
            border-bottom: none;
        }
    }

    .detail-info-item {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 24px;
        width: 100%;
        position: relative;
        align-items: center;
        // display: flex;
        // width: 100%;
        // margin-bottom: 24px;
        // flex-direction: column;

        &:last-child {
            margin-bottom: 0;
        }

        &-name {
            width: calc(100% - 84px);
            color: #333;
            font-size: 16px;
            float: right;
            padding-top: 10px;
            display: flex;
            padding-bottom: 8px;

            p {
                line-height: 24px;
                margin-bottom: 0;
                max-width: 178px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                &.date {
                    color: #333;
                    letter-spacing: 1px;
                    font-size: 15px;
                    margin-left: 8px;
                }
            }
        }

        &-name0 {
            width: 190px;
            flex-direction: column;
            color: #333;
            font-size: 16px;
            float: right;
            padding-top: 10px;
            display: flex;

            p {
                line-height: 24px;
                margin-bottom: 0;
                max-width: 178px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                &.date {
                    color: #333;
                    letter-spacing: 1px;
                    font-size: 15px;
                }
            }
        }

        &-content {
            // width: calc(100% - 264px);
            width: calc(100% - 84px);
            height: auto;
            border: 1px solid #e4e4e4;
            padding: 12px;
            border-radius: 4px;
            overflow-x: hidden;
            overflow-y: auto;
            cursor: not-allowed;
            color: #999;
            background: #f5f5f5;
            line-height: 24px;

            p {
                margin-bottom: 0;
                line-height: 28px;
                font-size: 16px;
                color: #333;
                letter-spacing: 1px;
            }

            td {
                color: #333;
            }

            img,
            video {
                max-width: 100%;
                border-radius: 8px;
                box-shadow: 0 0 10px #a2a2a2;
                margin: 8px 0;
                cursor: pointer;
            }
        }

        &-like {
            height: calc(100% - 24px);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            position: absolute;
            right: 0;
            cursor: pointer;

            > i {
                font-size: 18px;

                &.active {
                    color: #52c41a;
                }
            }
        }

        &:last-child {
            .detail-info-item-like {
                height: 100%;
            }
        }
    }

    .detail-info-items .detail-info-item:last-child .detail-info-item-like {
        height: 100%;
    }

    
    
    .details-isorter {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: right;
        align-items: center;
    }
}

.detail-info-comment {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
        width: 100%;

        .tinymce-editor {
            width: 100%;
        }

        &-btns {
            font-size: 20px;
            padding-top: 8px;

            button {
                margin-right: 16px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>